import { BREAKPOINTS, useBreakpoints } from '@bubble-ui/provider-responsive';
var breakpointKeys = Object.keys(BREAKPOINTS);
export var getActiveValue = (breakpoints, value) => {
  if (typeof value === 'undefined' || typeof value !== 'object') {
    return value;
  }
  var hasBreakpointKey = false;
  for (var index = breakpointKeys.length - 1; index >= 0; index--) {
    var breakpoint = breakpointKeys[index];
    var isActive = breakpoints[breakpoint];
    var valueForBreakpoint = value[breakpoint];
    if (typeof valueForBreakpoint !== 'undefined') {
      hasBreakpointKey = true;
      if (isActive) {
        return valueForBreakpoint;
      }
    }
  }

  // If has breakpoint but is not active, return undefined
  if (hasBreakpointKey) {
    return undefined;
  }

  // Not a breakpoint object
  return value;
};
export var useActiveStyles = styles => {
  var breakpoints = useBreakpoints();
  var activeStyleProps = {};
  Object.entries(styles).forEach(_ref => {
    var [property, value] = _ref;
    if (typeof value === 'undefined') {
      return;
    }
    activeStyleProps[property] = getActiveValue(breakpoints, value);
  });
  return activeStyleProps;
};
export var useActiveValue = value => {
  var breakpoints = useBreakpoints();
  return getActiveValue(breakpoints, value);
};
//# sourceMappingURL=breakpointUtils.js.map